var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0369 10.0711H13.4263V1.46227C13.4263 1.08352 13.2759 0.720278 13.0081 0.452459C12.7403 0.184639 12.377 0.0341797 11.9983 0.0341797C11.6195 0.0341797 11.2563 0.184639 10.9884 0.452459C10.7206 0.720278 10.5702 1.08352 10.5702 1.46227V10.0728H1.96129C1.58254 10.0728 1.2193 10.2233 0.951482 10.4911C0.683663 10.7589 0.533203 11.1222 0.533203 11.5009C0.533203 11.8797 0.683663 12.2429 0.951482 12.5107C1.2193 12.7785 1.58254 12.929 1.96129 12.929H10.5718V21.5396C10.5718 21.9183 10.7223 22.2816 10.9901 22.5494C11.2579 22.8172 11.6212 22.9676 11.9999 22.9676C12.3787 22.9676 12.7419 22.8172 13.0098 22.5494C13.2776 22.2816 13.428 21.9183 13.428 21.5396V12.9273H22.0386C22.4173 12.9273 22.7806 12.7769 23.0484 12.509C23.3162 12.2412 23.4667 11.878 23.4667 11.4992C23.4667 11.1205 23.3162 10.7572 23.0484 10.4894C22.7806 10.2216 22.4157 10.0711 22.0369 10.0711Z",
    fill: "#747478"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAdd);
export default __webpack_public_path__ + "static/media/create-add.50be1fcbcf018cc3fe7fec7d0ea0a526.svg";
export { ForwardRef as ReactComponent };